import {
  JournalEntryDetailSidepanelDocument,
  JournalEntryDetailSidepanelQuery,
} from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import JournalEntryDetailContent from 'modules/finance/components/JournalEntryDetailContent'

interface Props {
  journalEntryId: string
  onClose: () => void
}

const JournalEntryDetailSidepanel = ({ journalEntryId, onClose }: Props) => {
  const { data, loading } = useQuery<JournalEntryDetailSidepanelQuery, { id: string }>(
    JournalEntryDetailSidepanelDocument,
    {
      variables: {
        id: String(journalEntryId),
      },
    }
  )

  return (
    <Sidepanel
      title={i18n.t('finance.journal_entry.detail.title_v2', {
        number: data?.finance.journalEntry?.number || '',
      })}
      footer={null}
      width="wideXL"
      closeLabel={i18n.t('common.close')}
      onClose={onClose}
      overlay
      boxPadding
      open
      headerBorder
      locked
    >
      <JournalEntryDetailContent data={data} loading={loading} onClose={onClose} />
    </Sidepanel>
  )
}

export default JournalEntryDetailSidepanel
